const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/users/auth/login/`,
    LOGOUT: `${API_BASE_URL}/users/auth/logout/`,
    REGISTER: `${API_BASE_URL}/users/auth/register/`,
    DELETE_ACCOUNT: `${API_BASE_URL}/users/settings/delete-account/`, 
    FORGOT_PASSWORD: `${API_BASE_URL}/users/password/forgot-password/`, 
    RESET_PASSWORD: `${API_BASE_URL}/users/password/reset-password/`, 

    // Perhaps will utilize in the future
    // LOGOUT: `${API_BASE_URL}/users/auth/logout/`,
  },
  USERS: {
    PROFILE: (id) => id ? `${API_BASE_URL}/users/profile/${id}/` : `${API_BASE_URL}/users/profile/`,
    EDIT_PROFILE: `${API_BASE_URL}/users/profile/edit/`,
    PHOTO_UPLOAD: `${API_BASE_URL}/users/profile/photo-upload/`,
    DELETE_ACCOUNT: `${API_BASE_URL}/users/delete-account/`,
  },
};

export default API_ENDPOINTS; 